import { takeLatest, put, call } from 'redux-saga/effects';
import * as ServerOnActions from './action'
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { REPORT } from '../../../config'


export function* updateServerOnDates(action) {
    let requestUrl = `${REPORT}/serveron/update`;
    try {
        const uploadResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(ServerOnActions.updateServerOnDatesSuccess(uploadResult.data));
    } catch (err) {
        yield put(ServerOnActions.updateServerOnDatesFailure(err.response))
    }
}
export function* updateServerOnDatesData() {
    yield takeLatest(ServerOnActions.UPDATE_SERVER_ON_DATES, updateServerOnDates);
}